import { apiClient } from '../client';

export interface ActivitiesByUserRow {
  userId: number;
  userName: string;
  created: number;
  closed: number;
  open: number;
}

export interface SalesByStageRow {
  stage: string;
  pendingCount: number;
  pendingAmount: number;
  wonCount: number;
  wonAmount: number;
  lostCount: number;
}

export interface AccountsByCategoryRow {
  category: string;
  count: number;
}

export interface ReportPeriod {
  from?: string;
  to?: string;
}

export interface GlobalStats {
  totals: { accounts: number; persons: number; projects: number; sales: number };
  pipeline: Array<{ stage: string; count: number; amount: number }>;
  conversion: { won: number; lost: number; rate: number };
  accountsByMonth: Array<{ month: string; count: number }>;
  salesByMonth: Array<{ month: string; wonCount: number; wonAmount: number }>;
}

export const reportsApi = {
  async activitiesByUser(period: ReportPeriod): Promise<ActivitiesByUserRow[]> {
    const { data } = await apiClient.get<ActivitiesByUserRow[]>(
      '/reports/activities-by-user',
      { params: period },
    );
    return data;
  },
  async salesByStage(period: ReportPeriod): Promise<SalesByStageRow[]> {
    const { data } = await apiClient.get<SalesByStageRow[]>('/reports/sales-by-stage', {
      params: period,
    });
    return data;
  },
  async accountsByCategory(): Promise<AccountsByCategoryRow[]> {
    const { data } = await apiClient.get<AccountsByCategoryRow[]>(
      '/reports/accounts-by-category',
    );
    return data;
  },
  async stats(): Promise<GlobalStats> {
    const { data } = await apiClient.get<GlobalStats>('/reports/stats');
    return data;
  },
};
